import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { /* Link, */ Redirect } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Icon,
  IconButton,
  Avatar,
} from "@material-ui/core";
import ModalTravelInformation from "./ModalTravelInformation";
import { getCheckoutAction, addAction } from "../../../store/actions/index";
import moment from "moment";
import "moment/locale/es";
import "moment-timezone";
//import config from "../../../store/config/config.json"

import Image from "./../../../components/Image";
import CircularProgress from "@material-ui/core/CircularProgress";

import IconC from "./../../../components/_IconC";

class DetailRate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemsCart: this.props.itemsCart,
      totalPrice: this.props.totalPrice,
      segmentState: this.props.segmentState,
      pricesItem: this.props.pricesItem,
      idPrice: this.props.idPrice,
      loading: false,
      ages: this.props.ages,
      trainService: this.props?.itemsCart[0]?.offersId[0].operatingCarrier || ""
    };
    this.tokenClient = this.props.tokenClient;
    this.config = require(`../../../store/config/${this.tokenClient}/config.json`);
    this.apiToken = this.config.credential.api.token;
    this.nodePrice = this.config.pricing.search;
  }

  removeFromCart = (idItem) => {
    const segmentState = this.state.segmentState;
    const itemsCart = this.state.itemsCart;
    const pricesItem = this.state.pricesItem;
    const idPrice = this.state.idPrice;
    let totalPrice = 0;
    delete idPrice[idItem];
    delete itemsCart[idItem];
    pricesItem[idItem] = {
      price: parseInt(
        itemsCart[idItem]
          ? Math.sign(
              itemsCart[idItem].trainId.prices.api.values[this.nodePrice]
            ) *
              Math.floor(
                Math.abs(
                  itemsCart[idItem].trainId.prices.api.values[this.nodePrice]
                ) + 0.5
              )
          : 0
      ),
    };
    pricesItem.forEach(function (pr) {
      totalPrice += parseInt(
        Math.sign(pr.price) * Math.floor(Math.abs(pr.price) + 0.5)
      );
    });

    this.props.dispatchAddAction(
      itemsCart,
      totalPrice,
      idPrice,
      pricesItem,
      segmentState
    );
    this.setState({
      itemsCart: itemsCart,
      pricesItem: pricesItem,
      totalPrice: totalPrice,
      segmentState: segmentState,
      idPrice: idPrice,
    });
  };

  addCheckout = (itemCartSelect) => {
    let extraInfo = null;
    this.props.dispatchGetCheckout(
      extraInfo,
      itemCartSelect,
      this.tokenClient,
      this.apiToken,
      this.props.x_correlation_id
    );
    this.setState({ loading: true });
  };

  evalSeatReservationRepeated(segmento) {
    const seatReservations = [];
    for (var i = 0; i < segmento.length; i++) {
      seatReservations.push(segmento[i].seatReservationConditions);
    }
    return seatReservations.every((val, i, arr) => val === arr[0]);
  }

  render() {
    const totalPrice = this.state.totalPrice;
    const selectRadio = this.state.selectState;
    const itemCart = this.state.itemsCart;
    const emptyCart =
      this.state.itemsCart.filter(Boolean).length > 0 ? true : false;
    const GetButton = (props) => {
      const loading = this.state.loading;
      return (
        <Fragment>
          <div className={`containerButtonProgress`}>
            <div className={`wrapperButtonProgress`}>
              <Button
                disabled={loading}
                onClick={() => this.addCheckout(itemCart)}
                fullWidth
                variant="contained"
                color="primary"
              >
                Reservar
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  color="inherit"
                  className={`buttonProgress`}
                />
              )}
            </div>
          </div>
        </Fragment>
      );
    };

    return (
      <Fragment>
        <Card className="card-detail-rate">
          <CardHeader
            className="card-header"
            title={
              <Fragment>
                <div className="tarifa-head inverse">
                  <div className="content">
                    {emptyCart === false ? (
                      <Fragment>
                        <Typography variant="h3" className="title">
                          No hay tickets seleccionados
                        </Typography>
                        <Typography>
                          Selecciona tu ticket para continuar
                        </Typography>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <Typography variant="h3" className="title">
                          Total Boletos{" "}
                        </Typography>
                        <div>
                          <Typography>
                            <span className="price-currency">
                              {this.config.credential.currency}
                            </span>
                            <span className="price">
                              {" "}
                              {parseInt(this.state.totalPrice)}{" "}
                            </span>
                          </Typography>
                        </div>
                      </Fragment>
                    )}
                  </div>
                </div>
              </Fragment>
            }
          />

          <CardContent className="card-content">
            {emptyCart === false ? (
              <Fragment>
                <div className="btnResume">
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    disabled
                  >
                    Reservar
                  </Button>
                </div>
                <div className="image py-4 text-center">
                  <Image
                    img={`ticket.png`}
                    alt="No hay tickets seleccionados"
                  />
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <div className="tarifa-detail">
                  <div className="rows-tarifa">
                    {itemCart.map((item, i) =>
                      item ? (
                        <Grid container key={i}>
                          <Grid item xs={8}>
                            <Typography>
                              {" "}
                              {item.offersId[0].origin.localLabel} -{" "}
                              {
                                item.offersId[item.offersId.length - 1]
                                  .destination.localLabel
                              }
                            </Typography>
                          </Grid>
                          <Grid item xs={4} className="text-right">
                            <Typography>
                              {this.config.credential.currency}{" "}
                              {parseInt(
                                Math.sign(
                                  item?.trainId.prices.api.values[
                                    this.nodePrice
                                  ]
                                ) *
                                  Math.floor(
                                    Math.abs(
                                      item?.trainId.prices.api.values[
                                        this.nodePrice
                                      ]
                                    ) + 0.5
                                  )
                              )}{" "}
                            </Typography>
                          </Grid>
                        </Grid>
                      ) : (
                        ""
                      )
                    )}
                    <hr />
                    <Grid container className="row row-total">
                      <Grid item xs={8}>
                        <Typography>Total boletos</Typography>
                      </Grid>
                      <Grid item xs={4} className="text-right">
                        <Typography>
                          {this.config.credential.currency}{" "}
                          {parseInt(totalPrice)}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Typography className="row-total-leyend">
                      <span>
                        (Valor por total de pasajeros. No incluye gastos)
                      </span>
                    </Typography>
                  </div>
                </div>

                <div className="btnResume">
                  {this.props.preload ? (
                    <GetButton />
                  ) : (
                    <Redirect
                      to={{
                        pathname: "/" + this.tokenClient + "/trenes/checkout/",
                        state: { reserve: this.props.reserve },
                      }}
                    />
                  )}
                </div>

                <div className="card-products">
                  {itemCart.map((item, idItem) =>
                    item ? (
                      <Card className="card-product" key={idItem}>
                        <CardHeader
                          className="card-header card-header-product"
                          avatar={
                            <Avatar
                              aria-label="recipe"
                              className="avatar-product"
                            >
                              <Icon>train</Icon>
                            </Avatar>
                          }
                          title={
                            <span>
                              {item.offersId[0].origin.localLabel}
                              <Icon>arrow_forward</Icon>
                              {
                                item.offersId[item.offersId.length - 1]
                                  .destination.localLabel
                              }
                            </span>
                          }
                          subheader={
                            <span>
                              {moment(item.offersId[0].departure)
                                .locale("es")
                                .format("dddd, Do MMM YY")}
                            </span>
                          }
                          action={
                            <IconButton
                              aria-label="close"
                              onClick={() => this.removeFromCart(idItem)}
                            >
                              <Icon>close</Icon>
                            </IconButton>
                          }
                        />
                        <CardContent className="card-content card-content-product">
                          {/* {moment(item.offersId[0]?.departure).locale('es').format('dddd, Do MMM YY')} */}
                          <div className="tren">
                            <Grid container spacing={0}>
                              {/* <Grid item xs={4}>
                                                    <div className="img-rentadora">
                                                        <Image img={`thumb_default.png`} alt={'tren'} />
                                                    </div>
                                                </Grid> */}
                              <Grid item xs={12}>
                                <Grid container spacing={0}>
                                  <Grid item xs={6}>
                                    <div className="nro-tren">
                                      Tren N°:
                                      {item.offersId[0]?.vehicle.reference}{" "}
                                    </div>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <ModalTravelInformation
                                      type="escala"
                                      departure={moment(
                                        item.offersId[0].departure
                                      )
                                        .locale("es")
                                        .format("dddd, Do MMM YY")}
                                      origin={
                                        item.offersId[0].origin.localLabel
                                      }
                                      destination={
                                        item.offersId[item.offersId.length - 1]
                                          .destination.localLabel
                                      }
                                      segments={item.offersId}
                                      ages={this.props.ages}
                                      trainService={item.offersId[0].marketingCarrier}
                                      page="tickets"
                                    />
                                  </Grid>
                                </Grid>

                                <div className="nombre-tren">
                                  {" "}
                                  {item.offersId[0]?.vehicle.code}
                                </div>
                              </Grid>

                              <div className="clase">
                                {item?.trainId.comfortCategory.code}{" "}
                              </div>

                              <ul className="list-unstyled list-elements">
                                {item?.trainId.isDayPass && (
                                  <li>
                                    <Typography className="dayPassItem">
                                      <Icon className="icon">star</Icon> Day
                                      Pass
                                    </Typography>
                                  </li>
                                )}
                                <li>
                                  <Typography>
                                    <IconC
                                      icon="seat"
                                      alt="seat"
                                      className="custom_icon icon"
                                    />
                                    {this.evalSeatReservationRepeated(
                                      item.offersId
                                    ) ? (
                                      <span>
                                        {item.offersId[0].marketingCarrier ===
                                        "DBAHN" ? (
                                          <span
                                            style={{
                                              color: "red",
                                              important: true,
                                            }}
                                          >
                                            COSTO POR RESERVA DE ASIENTO NO
                                            INCLUIDO. EL MISMO SE ADICIONARA
                                            AUTOMÁTICAMENTE AL FINALIZAR LA
                                            EMISIÓN, EN CASO DE SER OBLIGATORIO
                                            (APROX. USD 6 POR PASAJERO POR
                                            TRAMO)
                                          </span>
                                        ) : (
                                          <span>
                                            {
                                              item.offersId[0]
                                                .seatReservationConditions
                                            }
                                          </span>
                                        )}
                                      </span>
                                    ) : (
                                      <span>
                                        La inclusión de asientos es variable en
                                        cada tramo. Haz clic en el link de las
                                        escalas para verificar detalle.
                                      </span>
                                    )}
                                  </Typography>
                                </li>
                                <li>
                                  <Typography>
                                    <Icon className="icon">
                                      confirmation_number
                                    </Icon>{" "}
                                    {item.trainId.ticketingOptions[0]}
                                  </Typography>
                                </li>
                                {                                       
                                  item.offersId[0].marketingCarrier ===
                                  "DBAHN" && 
                                  <li>
                                    <Typography>
                                        <Icon className="icon">
                                          info
                                        </Icon>
                                        <span>
                                          Tarifa Sparpreis: Si el ticket no es utilizado, se permite reembolso hasta 1 día antes de la fecha de salida del tren con una penalidad de Euros 10, el mismo se realizará por medio de un voucher para utilizar en futuros viajes en DB y deberá ser validado directamente en <a href="https://www.bahn.com/es/">https://www.bahn.com/es/</a>
                                        </span>
                                    </Typography>
                                  </li>
                                } 
                              </ul>
                           
                              <ModalTravelInformation
                                type="condiciones"
                                segmento={item.offersId}
                                detailConditions={item.dicProd}
                                ticketingOptions={item.trainId.ticketingOptions}
                                ages={this.props.ages}
                                trainService={item.offersId[0].marketingCarrier}
                                page="tickets"
                              />
                            </Grid>
                          </div>
                        </CardContent>
                      </Card>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </Fragment>
            )}
          </CardContent>
        </Card>
      </Fragment>
    );
  }
}

const mapStateToProps = (reducers) => {
  return reducers.checkoutReducer;
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchGetCheckout: (
      extraInfo,
      itemCart,
      tokenClient,
      apiToken,
      x_correlation_id
    ) => {
      dispatch(
        getCheckoutAction(
          extraInfo,
          itemCart,
          tokenClient,
          apiToken,
          x_correlation_id
        )
      );
    },
    dispatchAddAction: (itemsCart, totalPrice, pricesItem, segmentState) => {
      dispatch(addAction(itemsCart, totalPrice, pricesItem, segmentState));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailRate);
